import React from 'react';
export function ExpectationNoteSection() {
  return <section className="bg-[#FDF8F0] py-8 md:py-10 px-5" data-id="element-13">
      <div className="max-w-2xl mx-auto text-center" data-id="element-14">
        <p className="text-sm md:text-[0.9rem] text-[#6B5D4F] leading-relaxed" data-id="element-15">
          Este protocolo no reemplaza terapia ni atención médica. Está pensado
          como apoyo práctico para mamás que necesitan saber qué hacer en el
          momento real.
        </p>
      </div>
    </section>;
}